export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/dropdown-arrow.c60b5b73-8b04e3.svg";